import { useMemo } from 'react';
import { NextPage } from 'next';

import { PageSection } from 'types/pages';

import Head from 'components/layout/Head';
import PageContainer from 'components/layout/PageContainer';
import SectionsWrapper from 'components/layout/SectionsWrapper';

import SectionContact from './sections/Contact';
import SectionHero from './sections/Hero';
import SectionPlatform from './sections/Platform';
import SectionPricingPlans from './sections/PricingPlans';
import SectionSolution from './sections/Solution';
import StyledComponent from './styles';
import { Props } from './types';

const PageHome: NextPage<Props> = ({ localTranslations, metaTranslations }) => {
    const sections: PageSection[] = useMemo(() => [{
        slug: 'hero',
        order: 1,
        isVisible: true,
        children: (slug, translations) => (
            <SectionHero
                key={slug}
                translations={translations}
            />
        ),
    }, {
        slug: 'solucion',
        order: 2,
        isVisible: true,
        children: (slug, translations) => (
            <SectionSolution
                key={slug}
                translations={translations}
            />
        ),
    }, {
        slug: 'pricingPlans',
        order: 3,
        isVisible: true,
        children: (slug, translations) => (
            <SectionPricingPlans
                key={slug}
                translations={translations}
            />
        ),
    }, {
        slug: 'platform',
        order: 4,
        isVisible: true,
        children: (slug, translations) => (
            <SectionPlatform
                key={slug}
                translations={translations}
            />
        ),
    }, {
        slug: 'contact',
        order: 5,
        isVisible: true,
        children: (slug, translations) => (
            <SectionContact
                key={slug}
                translations={translations}
            />
        ),
    }], []);

    return (
        <StyledComponent className="page-home">
            <Head
                {...metaTranslations}
            />
            <PageContainer>
                <SectionsWrapper
                    sections={sections}
                    localTranslations={localTranslations}
                />
            </PageContainer>
        </StyledComponent>
    );
};

export default PageHome;
